var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIronAt110DegreeMaximum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8.28 7.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.67 0v.67h5.26l.23 2.44h-3a4.13 4.13 0 0 0 -4.16 4.12v.34h8.28l-.74-7.57zm-1 6.9a3.45 3.45 0 0 1 3.45-3.12h3.11l.3 3.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.49 4.67a.67.67 0 1 0 0 1.33.67.67 0 0 0 0-1.34z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIronAt110DegreeMaximum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "IronAt110DegreeMaximum.197c7b2f4cd751a525a4f2697d9f804b.svg";